import { Listener } from '../listenersStore';

const selectionLevelConfigListeners: Listener = {
  'refresh/selection-level-config': (dispatch: any, action: any) => {
    dispatch({
      type: 'FETCH_SELECTION_LEVEL_CONFIG_START',
      payload: { variables: { id: action.payload.projectId } },
    });
  },
};

export default selectionLevelConfigListeners;
